import { ChangeEvent } from "react";
import { cancelOrderApi, updateCustomerEmailApi, updateOrderStatusApi } from "../api";
import { custData } from "src/shared/services/interface";
import { notifyError, notifySuccess } from "src/assets/toastService";
import { CustomerData, Order } from "src/shared/services/interfacev2";
import { errorHandling } from "src/shared/utils/errorHandling";

export const updateCustomerEmail = async (
  getorder: Order | undefined,
  confirmemail: string,
  ordersucess: Order | undefined,
  email: string,
  setAgent: React.Dispatch<React.SetStateAction<boolean>>,
  setGeterror: React.Dispatch<React.SetStateAction<string>>,
  orderemailmsg: (
    order: Order,
    email: string,
    received: string,
    orderId: string,
    finalAmount: number,
    remaining: string,
    handleDone: () => void,
  ) => Promise<void>,
  customer: CustomerData | undefined,
) => {
  const customerId = getorder?.orders?.[0]?.customerId;

  if (!customerId) {
    notifyError("Customer ID is missing, cannot update email.");
    return;
  }

  if (!confirmemail || !customer) {
    notifyError("No email provided to update.");
    return;
  }

  // ✅ API DTO — NOT CustomerData
  const customerData: custData = {
    Name: customer.firstName ?? "",
    Email: confirmemail,
    Address: {
      customeraddress1: customer.addresses?.addressLine1 ?? "",
      customeraddress2: customer.addresses?.addressLine2 ?? "",
      customeraddress3: customer.addresses?.city ?? "",
    },
    phone_number: customer.phones?.[0]?.phone ?? "",
    alternativenumber: customer.phones?.[1]?.phone ?? "",
  };

  try {
    await updateCustomerEmailApi(customerId, customerData);

    setAgent(false);
    setGeterror("");

    if (!ordersucess?.paymentHistory?.length) return;

    orderemailmsg(
      getorder!,
      confirmemail,
      String(ordersucess.paymentHistory[0].receivedAmount),
      String(ordersucess.orders?.[0]?.orderId ?? ""),
      ordersucess.orders?.[0]?.finalAmount ?? 0,
      String(ordersucess.orders?.[0]?.remainingAmount ?? 0),
      () => {
        // ✅ what should happen after email success
        setAgent(false);
      },
    );
  } catch {
    notifyError("Email already exists");
  }
};

export const cancelOrder = async (
  orderid: string | undefined,
  cancelData: string,
  paymentMethod: string | undefined,
  setmove: Function
) => {
  try {
    await cancelOrderApi(orderid, cancelData, paymentMethod);

    setmove("Cancelled");
    notifySuccess("Order cancelled successfully");
  } catch (err) {
    errorHandling(err);
  }
};

export const handleChange = async (orderid: string | undefined, event: ChangeEvent<HTMLSelectElement>, setmove: Function, getOrdersIn: Function) => {
  try {
    await updateOrderStatusApi(orderid, event.target.value);
    setmove(event.target.value);
    getOrdersIn();
  } catch (err) {
    console.error(err);
  }
};

export const validateAndSetEmail = (
  value: string,
  setEmail: React.Dispatch<React.SetStateAction<string>>,
  setconfirmemail: React.Dispatch<React.SetStateAction<string>>,
) => {
  const isValidEmail = (value: string): boolean => {
    if (value.trim() === "") return false;
    if (!value.includes("@")) return false;
    const validDomains = [".com", ".in", ".co"];
    const hasValidDomain = validDomains.some((domain) => value.endsWith(domain));
    return hasValidDomain;
  };
  const emails = isValidEmail(value);
  if (emails) {
    setEmail(value);
    setconfirmemail(value);
  } else {
    setEmail(value);
  }
};
